import { SET_FILTERED_VEHICLES, CLEAR_FILTERED_VEHICLES, SET_VEHICLE_PAGE_NUMBER } from '../types';

const initialState = {
    filteredVehicles: [],
    pageNumber: 1,
};

const filterVehicleReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTERED_VEHICLES:
            return {
                ...state,
                filteredVehicles: action.payload,
            };
        case SET_VEHICLE_PAGE_NUMBER:
            return {
                ...state,
                pageNumber: action.payload,
            };
        case CLEAR_FILTERED_VEHICLES:
            return {
                ...state,
                filteredVehicles: [],
                organizationFilter: null,
                pageNumber: 1,
            };
        default:
            return state;
    }
}

export default filterVehicleReducer